/**
 * @file
 * Provide methods for showing and hiding dropdown elements.
 *
 * When a dropdown element is shown we listen for outside click events and
 * window resizing events to hide the dropdown element again.
 */

(function ($, Drupal) {
  Drupal.behaviors.dropdown = {
    attach: function attach(context) {
      let window_width_dropdown = $(window).width();
      $('.js-dropdown-trigger').on('click', function (event) {
        event.preventDefault();

        let $trigger = $(this);
        let $target = $trigger.siblings('.js-dropdown-target');

        if (!$target.is(':visible')) {
          $trigger.addClass('is-open').attr('aria-expanded', 'true');
          $target.fadeIn(200, function () {
            $(document).on('click', hideDropdown);
            $(window).on('resize', hideDropdownOnResize);
          });

          function hideDropdown(event) {
            if (!$(event.target).is($target) && !$(event.target).parents().is($target)) {
              $trigger.removeClass('is-open').attr('aria-expanded', 'false').blur();
              $target.fadeOut(200);
              $(document).off('click', hideDropdown);
            }
          }

          function hideDropdownOnResize(event) {
            let new_window_width = $(window).width();
            if (window_width_dropdown !== new_window_width) {
              if (!$(event.target).is($target) && !$(event.target).parents().is($target)) {
                $trigger.removeClass('is-open').attr('aria-expanded', 'false').blur();
                $target.fadeOut(200);
              }
              window_width_dropdown = new_window_width;
            }
          }
        }
      });
    }
  };
})(jQuery, Drupal);
